// extracted by mini-css-extract-plugin
export default {"card":"newCard_card__T3auH","container":"newCard_container__3mUCN","counter":"newCard_counter__ayTYb"};